
import { ACTIONS } from '_redux/actions';
import { post } from './api';

export function fetchTranslations(params) {
  return post('localisations',
    params,
    ACTIONS.TRANSLATIONS.FETCH_TRANSLATIONS,
    ACTIONS.TRANSLATIONS.FETCH_TRANSLATIONS_SUCCESS,
    ACTIONS.TRANSLATIONS.FETCH_TRANSLATIONS_ERROR);
}
